export const DEFAULT_POSITION_RANGES = {
  'UTG': {
    raisePercentage: '10.1%',
    foldPercentage: '89.9%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A5s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'JTs': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444'
    }
  },
  'UTG+1': {
    raisePercentage: '13.2%',
    foldPercentage: '86.8%',
    coloredCells: {
      // All pairs
      'AA': '#ff4444', 'KK': '#ff4444', 'QQ': '#ff4444',
      'JJ': '#ff4444', 'TT': '#ff4444', '99': '#ff4444',
      '88': '#ff4444', '77': '#ff4444', '66': '#ff4444',
      
      // All suited
      'AKs': '#ff4444', 'AQs': '#ff4444', 'AJs': '#ff4444',
      'ATs': '#ff4444', 'A9s': '#ff4444', 'A8s': '#ff4444',
      'A7s': '#ff4444', 'A6s': '#ff4444', 'A5s': '#ff4444',
      'A4s': '#ff4444', 'KQs': '#ff4444', 'KJs': '#ff4444',
      'KTs': '#ff4444', 'K9s': '#ff4444', 'QJs': '#ff4444',
      'QTs': '#ff4444', 'Q9s': '#ff4444', 'JTs': '#ff4444',
      'J9s': '#ff4444', 'T9s': '#ff4444', '98s': '#ff4444',
      '87s': '#ff4444',
      
      // All offsuit
      'AKo': '#ff4444', 'AQo': '#ff4444', 'AJo': '#ff4444',
      'KQo': '#ff4444'
    }
  },
  'UTG+2': {
    raisePercentage: '15.8%',
    foldPercentage: '84.2%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      '87s': '#ff4444',
      '76s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'KQo': '#ff4444'
    }
  },
  'LOJACK': {
    raisePercentage: '17.5%',
    foldPercentage: '82.5%',
    coloredCells: {
      // All pairs
      'AA': '#ff4444', 'KK': '#ff4444', 'QQ': '#ff4444',
      'JJ': '#ff4444', 'TT': '#ff4444', '99': '#ff4444',
      '88': '#ff4444', '77': '#ff4444', '66': '#ff4444',
      '55': '#ff4444', '44': '#ff4444',
      
      // All suited
      'AKs': '#ff4444', 'AQs': '#ff4444', 'AJs': '#ff4444',
      'ATs': '#ff4444', 'A9s': '#ff4444', 'A8s': '#ff4444',
      'A7s': '#ff4444', 'A6s': '#ff4444', 'A5s': '#ff4444',
      'A4s': '#ff4444', 'A3s': '#ff4444', 'A2s': '#ff4444',
      'KQs': '#ff4444', 'KJs': '#ff4444', 'KTs': '#ff4444',
      'K9s': '#ff4444', 'QJs': '#ff4444', 'QTs': '#ff4444',
      'Q9s': '#ff4444', 'JTs': '#ff4444', 'J9s': '#ff4444',
      'T9s': '#ff4444', '98s': '#ff4444', '87s': '#ff4444',
      '76s': '#ff4444', '65s': '#ff4444',
      
      // All offsuit
      'AKo': '#ff4444', 'AQo': '#ff4444', 'AJo': '#ff4444',
      'ATo': '#ff4444', 'KQo': '#ff4444', 'KJo': '#ff4444'
    }
  },
  'HIJACK': {
    raisePercentage: '20.1%',
    foldPercentage: '79.9%',
    coloredCells: {
      // All pairs
      'AA': '#ff4444', 'KK': '#ff4444', 'QQ': '#ff4444',
      'JJ': '#ff4444', 'TT': '#ff4444', '99': '#ff4444',
      '88': '#ff4444', '77': '#ff4444', '66': '#ff4444',
      '55': '#ff4444', '44': '#ff4444', '33': '#ff4444',
      '22': '#ff4444',
      
      // All suited
      'AKs': '#ff4444', 'AQs': '#ff4444', 'AJs': '#ff4444',
      'ATs': '#ff4444', 'A9s': '#ff4444', 'A8s': '#ff4444',
      'A7s': '#ff4444', 'A6s': '#ff4444', 'A5s': '#ff4444',
      'A4s': '#ff4444', 'A3s': '#ff4444', 'A2s': '#ff4444',
      'KQs': '#ff4444', 'KJs': '#ff4444', 'KTs': '#ff4444',
      'K9s': '#ff4444', 'K8s': '#ff4444', 'QJs': '#ff4444',
      'QTs': '#ff4444', 'Q9s': '#ff4444', 'JTs': '#ff4444',
      'J9s': '#ff4444', 'T9s': '#ff4444', 'T8s': '#ff4444',
      '98s': '#ff4444', '97s': '#ff4444', '87s': '#ff4444',
      '76s': '#ff4444', '65s': '#ff4444', '54s': '#ff4444',
      
      // All offsuit
      'AKo': '#ff4444', 'AQo': '#ff4444', 'AJo': '#ff4444',
      'ATo': '#ff4444', 'KQo': '#ff4444', 'KJo': '#ff4444',
      'QJo': '#ff4444'
    }
  },
  'CUTOFF': {
    raisePercentage: '25.6%',
    foldPercentage: '74.4%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      '44': '#ff4444',
      '33': '#ff4444',
      '22': '#ff4444',
      
      // Suited hands
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'K8s': '#ff4444',
      'K7s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'Q8s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'J8s': '#ff4444',
      'T9s': '#ff4444',
      'T8s': '#ff4444',
      '98s': '#ff4444',
      '97s': '#ff4444',
      '87s': '#ff4444',
      '86s': '#ff4444',
      '76s': '#ff4444',
      '75s': '#ff4444',
      '65s': '#ff4444',
      '64s': '#ff4444',
      '54s': '#ff4444',
      '43s': '#ff4444',
      
      // Offsuit hands
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'ATo': '#ff4444',
      'KQo': '#ff4444',
      'KJo': '#ff4444',
      'QJo': '#ff4444'
    }
  },
  'BUTTON': {
    raisePercentage: '45.8%',
    foldPercentage: '54.2%',
    coloredCells: {
      // All pairs
      'AA': '#ff4444', 'KK': '#ff4444', 'QQ': '#ff4444',
      'JJ': '#ff4444', 'TT': '#ff4444', '99': '#ff4444',
      '88': '#ff4444', '77': '#ff4444', '66': '#ff4444',
      '55': '#ff4444', '44': '#ff4444', '33': '#ff4444',
      '22': '#ff4444',
      
      // All suited
      'AKs': '#ff4444', 'AQs': '#ff4444', 'AJs': '#ff4444',
      'ATs': '#ff4444', 'A9s': '#ff4444', 'A8s': '#ff4444',
      'A7s': '#ff4444', 'A6s': '#ff4444', 'A5s': '#ff4444',
      'A4s': '#ff4444', 'A3s': '#ff4444', 'A2s': '#ff4444',
      'KQs': '#ff4444', 'KJs': '#ff4444', 'KTs': '#ff4444',
      'K9s': '#ff4444', 'K8s': '#ff4444', 'K7s': '#ff4444',
      'K6s': '#ff4444', 'K5s': '#ff4444', 'K4s': '#ff4444',
      'K3s': '#ff4444', 'K2s': '#ff4444', 'QJs': '#ff4444',
      'QTs': '#ff4444', 'Q9s': '#ff4444', 'Q8s': '#ff4444',
      'Q7s': '#ff4444', 'Q6s': '#ff4444', 'Q5s': '#ff4444',
      'JTs': '#ff4444', 'J9s': '#ff4444', 'J8s': '#ff4444',
      'J7s': '#ff4444', 'T9s': '#ff4444', 'T8s': '#ff4444',
      'T7s': '#ff4444', '98s': '#ff4444', '97s': '#ff4444',
      '96s': '#ff4444', '87s': '#ff4444', '86s': '#ff4444',
      '85s': '#ff4444', '76s': '#ff4444', '75s': '#ff4444',
      '74s': '#ff4444', '65s': '#ff4444', '64s': '#ff4444',
      '63s': '#ff4444', '54s': '#ff4444', '53s': '#ff4444',
      '43s': '#ff4444', '32s': '#ff4444',
      
      // All offsuit
      'AKo': '#ff4444', 'AQo': '#ff4444', 'AJo': '#ff4444',
      'ATo': '#ff4444', 'A9o': '#ff4444', 'A8o': '#ff4444',
      'A7o': '#ff4444', 'A6o': '#ff4444', 'A5o': '#ff4444',
      'A4o': '#ff4444', 'KQo': '#ff4444', 'KJo': '#ff4444',
      'KTo': '#ff4444', 'K9o': '#ff4444', 'QJo': '#ff4444',
      'QTo': '#ff4444', 'JTo': '#ff4444'
    }
  }
}; 